// src/ecrans/orchestrateur/stock-calculs.js — Stock de l'orchestrateur (pur,
// testé). Sous le seuil = strictement en dessous, comme la maquette (« 2 pastilles,
// seuil 2 : au-dessus du seuil »). ⚠️ src/lib/stock-alerte.js reste à `<=` : il est
// partagé avec les écrans de l'admin, qui ne changent pas ici. La pastille Stock
// de l'orchestrateur suit la vue (`compterSousSeuil`).

const estSous = (c) => c.qty !== null && c.qty !== undefined && c.seuil > 0 && c.qty < c.seuil;

/** La pastille Stock de l'orchestrateur : `stockCentral` de l'appli, même règle que sa vue. */
export function compterSousSeuil(stockCentral) {
  return Object.values(stockCentral || {}).filter((p) => estSous({ qty: p?.qtyDispo ?? null, seuil: p?.seuilMin })).length;
}

/** Un nom de produit ; jamais son identifiant technique. */
export const nomDe = (c) => c.nom || "produit retiré du catalogue";

/** Ce qu'il faut racheter pour revenir à deux fois le seuil (maquette). */
export function aRacheter(c) {
  return Math.max(0, 2 * (c.seuil || 0) - (c.qty || 0));
}

/** Les produits sous leur seuil. */
export function sousLeSeuil(central) {
  return (central || []).filter(estSous);
}

/** Les deux groupes de la maquette, puis ce qui n'a plus de fiche. */
export function groupesCentral(central) {
  const liste = central || [];
  return [
    { id: "kit", titre: "Kit", produits: liste.filter((c) => c.categorie === "kit") },
    { id: "operationnel", titre: "Opérationnel", produits: liste.filter((c) => c.categorie === "operationnel") },
    { id: "autres", titre: "Sans catégorie", produits: liste.filter((c) => c.categorie !== "kit" && c.categorie !== "operationnel") },
  ].filter((g) => g.produits.length);
}

/** « 14 rouleaux », « 1 dose », « — » si la quantité est inconnue. */
export function quantiteLue(c) {
  if (c.qty === null || c.qty === undefined) return "—";
  if (!c.unite) return String(c.qty);
  return `${c.qty} ${c.unite}${c.qty > 1 && !/s$/.test(c.unite) ? "s" : ""}`;
}

/** La phrase de la fiche produit. */
export function phraseSeuil(c) {
  if (c.qty === null || !c.seuil) return "Pas de seuil réglé.";
  if (!estSous(c)) return `Au-dessus du seuil de ${c.seuil}.`;
  const manque = aRacheter(c);
  return `Sous le seuil de ${c.seuil} — il en manque ${manque} pour revenir au plein.`;
}

/** Le texte copié par « Copier la liste ». */
export function texteListe(central) {
  return sousLeSeuil(central)
    .map((c) => `${nomDe(c)} : + ${aRacheter(c)}`)
    .join("\n");
}

/** « 4,80 € » ; « — » si le prix est inconnu, jamais 0. */
export function prixLu(p) {
  if (p === null || p === undefined) return "—";
  return `${Number(p).toFixed(2).replace(".", ",")} €`;
}
